import { Controller } from "@hotwired/stimulus"

// Row-click navigation for admin collection tables.
//
// Administrate's own `table` controller only skips the row navigation when the
// clicked element has an `href`, so a `button_to` control in the row (e.g. the
// Destroy button, which is a <button> with no href) falls through and also
// Turbo.visit()s the row. This override skips any interactive control, so those
// buttons run their own action without navigating the row.
export default class extends Controller {
  visitDataUrl(event) {
    if (event.type !== "click" && event.keyCode !== 32 && event.keyCode !== 13) return
    if (event.target.closest("a, button, input, select, textarea, label")) return

    const row = event.target.closest("tr")
    const dataUrl = row && row.dataset.url
    if (dataUrl && window.getSelection().toString().length === 0) {
      window.Turbo.visit(dataUrl)
    }
  }
}
